import React from 'react';

const Menu = (props) => {
    return (
        <div className="bg-white rounded shadow p-4">
            <h2 className="text-center">Menu Utama</h2>
            <div className="my-1"/>
            <div className="row px-4">
                <div className="p-2 col-3">
                    <button
                    className="btn btn-outline-primary btn-block"
                    onClick={() => window.location.assign(`/admin/orders`)}
                    >
                        Semua Order
                    </button>
                </div>
                <div className="p-2 col-3">
                    <button
                    className="btn btn-outline-primary btn-block"
                    onClick={() => window.location.assign(`/admin/purchase-orders`)}
                    >
                        Purchase Order Supplier
                    </button>
                </div>
                <div className="p-2 col-3">
                    <button
                    className="btn btn-outline-primary btn-block"
                    onClick={() => window.location.assign(`/admin/transactions`)}
                    >
                        Transaksi Keuangan
                    </button>
                </div>
                <div className="p-2 col-3">
                    <button
                        className="btn btn-outline-primary btn-block"
                        onClick={() => window.location.assign(`/admin/orders/new/bulk`)}
                    >
                        Upload Order Marketplace
                    </button>
                </div>
            </div>
            <div className="my-1"/>
            <div className="row px-4">
                <div className="p-2 col-3">
                    <button
                        className="btn btn-outline-info btn-block"
                        onClick={() => window.location.assign(`/admin/orders/status/placed`)}
                    >
                        Order dikirim nanti
                    </button>
                </div>
                <div className="p-2 col-3">
                    <button
                        className="btn btn-outline-danger btn-block"
                        onClick={() => window.location.assign(`/admin/orders/status/confirmed`)}
                    >
                        Order kirim sekarang
                    </button>
                </div>
                <div className="p-2 col-3">
                    <button
                        className="btn btn-outline-success btn-block"
                        onClick={() => window.location.assign(`/admin/orders/status/delivered`)}
                    >
                        Order selesai
                    </button>
                </div>
                <div className="p-2 col-3">
                    <button
                        className="btn btn-outline-warning btn-block"
                        onClick={() => window.location.assign(`/admin/orders/status/cancelled`)}
                    >
                        Order cancel
                    </button>
                </div>
            </div>
            <div className="my-1"/>
            <div className="row px-4">
                <div className="p-2 col-3">
                    <button
                        className="btn btn-outline-primary btn-block"
                        onClick={() => window.location.assign(`/admin/users`)}
                    >
                        List User
                    </button>
                </div>
                <div className="p-2 col-3">
                    <button
                        className="btn btn-outline-primary btn-block"
                        onClick={() => window.location.assign(`/admin/stock-update`)}
                    >
                        Update Stok
                    </button>
                </div>
                <div className="p-2 col-3">
                    <button
                        className="btn btn-outline-primary btn-block"
                        onClick={() => window.location.assign(`/admin/postal-code`)}
                    >
                        Perbaikan Kode Pos
                    </button>
                </div>
            </div>
        </div>
    )
};

export default Menu;
